import { render, staticRenderFns } from "./redbox.vue?vue&type=template&id=50fba8d6&"
import script from "./redbox.vue?vue&type=script&lang=js&"
export * from "./redbox.vue?vue&type=script&lang=js&"
import style0 from "./redbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports